// src/layout/builders/status/StatusBadge.jsx
import React, { useState } from "react";
import StatusChangePopup from "./StatusChangePopup";
import statusClasses from "./statusClasses";

// REMOVED onStatusChangeError prop
const StatusBadge = ({ project, handleStatusChange, allowedNextStatuses }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isChangeDisabled = isLoading || !allowedNextStatuses || allowedNextStatuses.length === 0;
  const currentStatusStyle = statusClasses[project.status] || { bg: 'bg-gray-100', text: 'text-gray-700', dot: 'bg-gray-500' };

  const handleOpenPopup = () => {
    if (!isChangeDisabled) {
      setIsPopupOpen(true);
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleConfirmStatus = async (projectId, newStatus, comment) => {
    setIsLoading(true);
    try {
      // Call the main handler passed down (e.g., from LiveTable)
      // The parent now handles the result and potential redirection
      const result = await handleStatusChange(projectId, newStatus, comment);

      // Close the popup if the operation didn't inherently fail
      // (e.g., API errors are handled by toast in store, missing docs redirect happens in parent)
      // We can generally close it unless the parent explicitly needs it open.
      if (result?.success || result?.reason !== 'missing_docs') { // Close unless explicitly told not to (like missing docs redirect) - Parent handles the missing docs redirect now.
          setIsPopupOpen(false);
      }

    } catch (error) {
      // Catch unexpected errors during the call *to* handleStatusChange
      console.error("Error during status confirmation in badge:", error);
      // Close popup on unexpected errors
      setIsPopupOpen(false);
    } finally {
      setIsLoading(false);
    }
  };

  const formatStatusLabel = (key) => {
     if (!key) return 'N/A';
     return key.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  return (
    <>
      <button
        onClick={handleOpenPopup}
        disabled={isChangeDisabled}
        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium transition-shadow duration-200 ${
          currentStatusStyle.bg
        } ${currentStatusStyle.text} ${
            isChangeDisabled
             ? 'cursor-not-allowed opacity-70'
             : 'cursor-pointer hover:shadow-md'
        }`}
      >
        <span
          className={`h-1.5 w-1.5 rounded-full ${
            currentStatusStyle.dot
          } mr-1`}
        ></span>
        {formatStatusLabel(project.status)}
      </button>

      <StatusChangePopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        currentStatus={project.status}
        availableStatuses={allowedNextStatuses || []}
        projectId={project.id}
        onConfirm={handleConfirmStatus} // Passes call up to parent
        isLoading={isLoading}
        // REMOVED onStatusChangeError prop
      />
    </>
  );
};

export default StatusBadge;